import React, { FC, useMemo } from 'react';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { useStyles } from './styles';

const TitleContainer: FC = ({ children }) => {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const type = useMemo(() => engine.getSubjectData(id).type, [engine, id]);
  const styles = useStyles([type]);

  return (
    <div aria-label="subject title container" className={styles.titleContainer}>
      {children}
    </div>
  );
};

export default TitleContainer;
